module.exports = "/assets/landing-rw/instagram/insta-feed-4@2x.jpg?5dgK2B+";